import React, { useState } from 'react';
import './AuthModal.css'; // 기존 스타일 재사용
import headerLogo from '../assets/차트트레이너.png';

interface ConsentModalProps {
  isOpen: boolean;
  email: string;
  nickname: string;
  onAgree: () => Promise<void>;
  onCancel: () => void;
  theme: 'light' | 'dark';
}

const ConsentModal: React.FC<ConsentModalProps> = ({
  isOpen,
  email,
  nickname,
  onAgree,
  onCancel,
  theme,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleAgree = async () => {
    setIsLoading(true);
    setError('');
    try {
      await onAgree();
    } catch (err: any) {
      setError(err.message || '가입 처리 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="auth-modal-overlay" 
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
      }}
    >
      <div 
        className={`auth-modal ${theme}`}
        style={{
          maxWidth: '500px',
          backgroundColor: theme === 'dark' ? '#2a2a2a' : '#ffffff',
        }}
      >
        <div 
          className="auth-modal-header"
          style={{
            backgroundColor: theme === 'dark' ? '#1a1a1a' : '#fee500',
            borderBottom: theme === 'dark' ? '1px solid #444' : 'none',
            padding: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
          }}
        >
          <img 
            src={headerLogo} 
            alt="차트트레이너" 
            style={{
              width: '32px',
              height: '32px',
              objectFit: 'contain',
            }}
          />
          <h2 style={{
            color: theme === 'dark' ? '#ffffff' : '#000000',
            fontSize: '18px',
            fontWeight: 'bold',
            margin: 0,
          }}>
            차트트레이너 서비스 이용 동의
          </h2>
        </div>

        <div className="auth-modal-content" style={{ padding: '24px' }}>
          <div style={{ 
            marginBottom: '24px',
            textAlign: 'center',
            padding: '16px',
            backgroundColor: theme === 'dark' ? '#1a1a1a' : '#f8f9fa',
            borderRadius: '8px',
          }}>
            <p style={{ 
              fontSize: '15px',
              color: theme === 'dark' ? '#ffffff' : '#1a1a1a',
              marginBottom: '8px',
            }}>
              <strong>{nickname}</strong> 님
            </p>
            <p style={{ 
              fontSize: '13px',
              color: theme === 'dark' ? '#aaa' : '#666',
              marginBottom: '4px',
            }}>
              {email}
            </p>
            <p style={{ 
              fontSize: '14px',
              color: theme === 'dark' ? '#ccc' : '#444',
              marginTop: '12px',
              fontWeight: '500',
            }}>
              차트트레이너를 이용하려면 아래 항목에 동의해주세요
            </p>
          </div>

          <div
            style={{
              border: theme === 'dark' ? '1px solid #444' : '1px solid #e0e0e0',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '16px',
              backgroundColor: theme === 'dark' ? '#1e1e1e' : '#ffffff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
              <input
                type="checkbox"
                checked
                disabled
                style={{ 
                  marginRight: '10px',
                  cursor: 'not-allowed',
                  width: '18px',
                  height: '18px',
                }}
              />
              <strong style={{ 
                fontSize: '15px',
                color: theme === 'dark' ? '#ffffff' : '#1a1a1a',
              }}>
                [필수] 개인정보 수집·이용 동의
              </strong>
            </div>
            <div
              style={{
                fontSize: '14px',
                color: theme === 'dark' ? '#d0d0d0' : '#333333',
                paddingLeft: '28px',
                lineHeight: '1.8',
              }}
            >
              <p style={{ margin: '8px 0' }}>
                • <strong>수집 항목:</strong> 카카오 계정 이메일
              </p>
              <p style={{ margin: '8px 0' }}>
                • <strong>이용 목적:</strong> 회원 식별, 게임 기록 저장, 랭킹 제공
              </p>
              <p style={{ margin: '8px 0' }}>
                • <strong>보유 기간:</strong> 회원 탈퇴 시까지 (탈퇴 시 즉시 삭제)
              </p>
              <p style={{ margin: '8px 0', fontSize: '13px', color: theme === 'dark' ? '#999' : '#666' }}>
                ※ 닉네임은 임의로 생성되며 카카오 정보를 사용하지 않습니다
              </p>
            </div>
          </div>

          <div
            style={{
              border: theme === 'dark' ? '1px solid #444' : '1px solid #e0e0e0',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '24px',
              backgroundColor: theme === 'dark' ? '#1e1e1e' : '#ffffff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
              <input
                type="checkbox"
                checked
                disabled
                style={{ 
                  marginRight: '10px',
                  cursor: 'not-allowed',
                  width: '18px',
                  height: '18px',
                }}
              />
              <strong style={{ 
                fontSize: '15px',
                color: theme === 'dark' ? '#ffffff' : '#1a1a1a',
              }}>
                [필수] 이용약관 동의
              </strong>
            </div>
            <div
              style={{
                fontSize: '14px',
                color: theme === 'dark' ? '#d0d0d0' : '#333333',
                paddingLeft: '28px',
                lineHeight: '1.8',
              }}
            >
              <p style={{ margin: '8px 0' }}>
                • 본 서비스는 주식 매매 연습을 위한 <strong>교육용 게임</strong>입니다
              </p>
              <p style={{ margin: '8px 0' }}>
                • 실제 금융 투자와 무관하며 <strong>가상의 데이터</strong>를 사용합니다
              </p>
              <p style={{ margin: '8px 0' }}>
                • 게임 내 랭킹 및 데이터는 <strong>서비스 정책에 따라 변경</strong>될 수 있습니다
              </p>
              <p style={{ 
                margin: '12px 0 8px 0', 
                padding: '10px',
                backgroundColor: theme === 'dark' ? '#2a1a1a' : '#fff3e0',
                border: `1px solid ${theme === 'dark' ? '#ff6b6b' : '#ff9800'}`,
                borderRadius: '6px',
                fontSize: '13px',
                color: theme === 'dark' ? '#ff6b6b' : '#e65100',
                fontWeight: 'bold',
              }}>
                ⚠️ 금융투자업법 관련 안내
              </p>
              <p style={{ 
                margin: '8px 0', 
                fontSize: '13px', 
                color: theme === 'dark' ? '#ff6b6b' : '#d84315',
                paddingLeft: '8px',
              }}>
                본 서비스는 금융투자업법에 따른 투자자문업, 투자일임업, 집합투자업 등에 해당하지 않으며, 
                실제 투자 조언이나 투자 권유를 제공하지 않습니다. 게임 내 AI 분석 결과는 교육 목적의 
                참고용이며, 실제 투자 결정에 사용해서는 안 됩니다. 실제 투자로 인한 손실에 대해서는 
                본 서비스가 책임을 지지 않습니다.
              </p>
              <p style={{ margin: '8px 0', fontSize: '13px', color: theme === 'dark' ? '#999' : '#666' }}>
                ※ 서버 점검, 업데이트 등으로 일시적으로 서비스가 중단될 수 있습니다
              </p>
            </div>
          </div>

          {error && (
            <div
              style={{
                padding: '12px 16px',
                marginBottom: '20px',
                backgroundColor: '#fff3f3',
                border: '1px solid #ffcdd2',
                borderRadius: '8px',
                color: '#c62828',
                fontSize: '14px',
                textAlign: 'center',
              }}
            >
              ⚠️ {error}
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
            <button
              onClick={handleAgree}
              disabled={isLoading}
              className="auth-submit-btn"
              style={{
                flex: 1,
                padding: '14px 20px',
                backgroundColor: isLoading ? '#f0e68c' : '#fee500',
                color: '#000000',
                border: 'none',
                borderRadius: '10px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: isLoading ? 'none' : '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              {isLoading ? '⏳ 처리 중...' : '✓ 동의하고 시작하기'}
            </button>
            <button
              onClick={onCancel}
              disabled={isLoading}
              style={{
                padding: '14px 20px',
                backgroundColor: theme === 'dark' ? '#333' : '#e0e0e0',
                color: theme === 'dark' ? '#ccc' : '#666',
                border: 'none',
                borderRadius: '10px',
                fontSize: '14px',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              취소
            </button>
          </div>

          <div
            style={{
              padding: '12px',
              fontSize: '12px',
              color: theme === 'dark' ? '#888' : '#999',
              textAlign: 'center',
              backgroundColor: theme === 'dark' ? '#1a1a1a' : '#f5f5f5',
              borderRadius: '6px',
            }}
          >
            ℹ️ 동의를 거부하시면 서비스 이용이 불가능합니다
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
